/* CEOREBEL luxury interaction layer — small, progressive, reduced-motion aware. */
(() => {
  'use strict';
  if (window.CEOLuxuryMotion) return;

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const root = document.documentElement;
  const observed = new WeakSet();
  let observer;

  const markKeyboard = (event) => {
    if (event.key === 'Tab' || event.key.startsWith('Arrow') || event.key === 'Enter' || event.key === ' ') {
      root.classList.add('keyboard-nav');
    }
  };
  const markPointer = () => root.classList.remove('keyboard-nav');

  document.addEventListener('keydown', markKeyboard, true);
  document.addEventListener('pointerdown', markPointer, { capture: true, passive: true });
  document.addEventListener('touchstart', markPointer, { capture: true, passive: true });

  const reveal = (node) => node.classList.add('is-revealed');

  const getObserver = () => {
    if (observer || reduced.matches || !('IntersectionObserver' in window)) return observer;
    observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        reveal(entry.target);
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    return observer;
  };

  const prepareNode = (node, className, delay = 0) => {
    if (!node || observed.has(node)) return;
    observed.add(node);
    node.classList.add(className);
    if (delay) node.style.transitionDelay = `${delay}ms`;

    const rect = node.getBoundingClientRect();
    const alreadyVisible = rect.top < window.innerHeight * 0.92 && rect.bottom > 0;
    if (reduced.matches || alreadyVisible || !getObserver()) reveal(node);
    else observer.observe(node);
  };

  const init = (scope = document) => {
    if (!document.body?.classList.contains('motion-enabled')) return;
    const main = document.getElementById('MainContent');
    if (!main) return;

    const sectionCandidates = [];
    if (scope === document) sectionCandidates.push(...main.querySelectorAll(':scope > .shopify-section'));
    else if (scope.classList?.contains('shopify-section')) sectionCandidates.push(scope);
    else sectionCandidates.push(...scope.querySelectorAll?.('.shopify-section') || []);

    sectionCandidates.forEach((section) => prepareNode(section, 'luxury-reveal'));

    const cards = scope.querySelectorAll?.('.product-card,.yzy-product') || [];
    cards.forEach((card, index) => prepareNode(card, 'luxury-card-reveal', Math.min((index % 6) * 38, 190)));
  };

  document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  reduced.addEventListener?.('change', () => {
    if (reduced.matches) {
      observer?.disconnect();
      observer = undefined;
      document.querySelectorAll('.luxury-reveal,.luxury-card-reveal').forEach(reveal);
    }
  });

  window.CEOLuxuryMotion = { init };
})();
